import { injectTransportMeterNodes } from "@/client/core/audio/Audio";
import type { ElementaryService, ElementaryGraphFunction } from "@/client/core/Core.api";
import type { LabsElementaryGraph } from "@/client/core/platform-types/labs.api";

export const createElementaryServiceForPlugin = (
    sendElementaryGraph: ElementaryGraphFunction,
): ElementaryService => {
    const setGraph = (graph: Readonly<LabsElementaryGraph>): void => {
        injectTransportMeterNodes(graph);
        sendElementaryGraph(graph);
    };

    return { setGraph };
};
